/* Constants */
import {
  EXPERIMENT_COOKIE_DELIMITER,
  EXPERIMENT_DELIMITER,
  EXPERIMENT_NAME_INDEX_IN_ARRAY,
  BUCKET_NAME_INDEX_IN_ARRAY,
  PAYLOAD_INDEX_IN_ARRAY,
} from './experimentConstants';

/* Utils */
import {
  createImmutableMapFromArray,
} from '../../common/collection/collectionUtils';
import {
  hexToString,
} from '../../common/string/stringUtils';

function generateExperimentMapElementTransformer(accMap, element, config) {
  const {propertyName} = config;

  accMap.set(element[propertyName], element);

  return accMap;
}

function generateExperimentMap(rawExperimentArray) {
  return createImmutableMapFromArray(
    rawExperimentArray,
    {
      propertyName: 'name',
      transformer: generateExperimentMapElementTransformer,
    }
  )
}

function experimentParse(rawExperiment) {
  const experiment = rawExperiment?.split(EXPERIMENT_DELIMITER);
  if (!experiment?.length) {
    return false;
  }

  return {
    name: experiment[EXPERIMENT_NAME_INDEX_IN_ARRAY],
    bucket: experiment[BUCKET_NAME_INDEX_IN_ARRAY],
    payload: experiment[PAYLOAD_INDEX_IN_ARRAY],
  }
}

function experimentCookieParse(rawCookie) {
  const rawExperiments = rawCookie && hexToString(rawCookie)?.split(EXPERIMENT_COOKIE_DELIMITER);

  return rawExperiments?.reduce((experiments, rawExperiment) => {
    const experiment = experimentParse(rawExperiment);
    if (experiment) {
      experiments[experiment.name] = experiment;
    }
    return experiments;
  }, {});
}

function experimentCookieListParse(cookieNames, cookies) {
  const experiments = cookieNames?.reduce((experiments, cookieName) => {
    const rawCookie = cookies?.[cookieName];
    return {
      ...experiments,
      ...rawCookie && experimentCookieParse(rawCookie),
    };
  }, {});

  return Object.values(experiments);
}

export {
  generateExperimentMapElementTransformer,
  generateExperimentMap,
  experimentCookieParse,
  experimentCookieListParse,
};
